import * as React from 'react';
import c from 'classnames';

import s from './ExclusiveMaskIcon.scss';

type Props = {
  className?: string;
  onClick?: () => void;
};

const SvgIcon = (props: Props) => (
  <button
    type="button"
    onClick={props.onClick}
    className={c(s['root'], props.className)}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="10"
      fill="none"
      viewBox="0 0 20 10"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18.562 4.952c.143-.86.455-1.597.76-2.314.337-.796 1.063-2.626-.117-1.892-.428.266-.66.426-1.221.48-.808.078-1.305-.312-1.912-.465-.18-.046-.372-.095-.576-.138-1.716-.37-2.623.106-3.503.568-.4.21-.794.416-1.25.555a.3.3 0 0 1-.112.034q-.275.077-.587.113a.3.3 0 0 1-.08.002c-.786-.09-1.366-.394-1.956-.704C7.128.731 6.22.254 4.504.623 4.3.666 4.11.715 3.93.76c-.607.153-1.104.544-1.912.466-.563-.055-.793-.215-1.222-.48C-.385.012.34 1.841.679 2.637c.304.718.616 1.454.759 2.314.04.24.065.402.09.56.07.469.138.911.236 1.276.25.926.89 1.68 1.7 2.158.833.49 1.845.688 2.796.482.559-.12 1.062-.316 1.543-.5.732-.284 1.417-.549 2.198-.549s1.467.264 2.199.548c.48.185.984.38 1.543.501.95.206 1.961.01 2.795-.482.81-.478 1.449-1.23 1.7-2.158.098-.365.165-.807.236-1.276.023-.158.048-.32.088-.56M11.114 6.2c1.124-3.12 2.634-3.346 5.59-1.736-.605 2.258-2.115 2.484-5.59 1.736m-7.82-1.736C6.25 2.854 7.762 3.079 8.885 6.2c-3.474.748-4.984.522-5.59-1.736"
        clipRule="evenodd"
      ></path>
    </svg>
  </button>
);

export default SvgIcon;
